export default __webpack_public_path__ + "static/media/eth-logo.80a9823c.png";